import useSelectedMasterProject from '../hooks/useSelectedMasterProject';
import MasterConfigSections from '../ui/MasterConfigSections';

const MasterConfigTab = () => {
  const { data: master, isError, isLoading, selectedId } = useSelectedMasterProject();

  if (selectedId == null) {
    return (
      <section>
        <p className="text-sm text-text-muted">Selecciona una inmobiliaria desde el sidebar.</p>
      </section>
    );
  }

  if (isLoading || !master) {
    return (
      <section>
        <p className="text-sm text-text-muted">Cargando...</p>
      </section>
    );
  }

  if (isError) {
    return (
      <section>
        <p className="text-sm text-destructive">No se pudo cargar la configuración del master.</p>
      </section>
    );
  }

  return <MasterConfigSections project={master} />;
};

export default MasterConfigTab;
